/**
 * @module 项目管理-路由配置
 * @author Teacher Tang
 * @date 2019-09-23 11:04:10
 */
// 布局
import React from 'react';
import { LayoutBase } from '../layout/index';
// 页面（按需包装布局）
import {
  Home,
  Login,
  MyTask,
  TaskDetail,
  ProjectList,
  ProjectDetail,
  ProjectCreate,
  ProjectHome,
  TaskCreate,
  Descript,
  Privacy,
  Legal,
  AppLegal,
  AppPrivacy,
  AuthCompany,
  WorkbenchIntro,
  FilePreview,
  UpgradeTips,
  AntPay,
  AntPayResult,
  PersonalVerify,
  AppDownload
} from '../pages';

// 路由设置（被嵌套组件，需支持children）
export default {
  path: '/',
  component: LayoutBase,
  routes: [
    {
      path: '/',
      isExact: true,
      component: Home
    },
    {
      path: '/login',
      isExact: true,
      component: Login
    },
    {
      // 任务协作首页
      path: '/company/home',
      component: ProjectHome,
      isExact: true
    },
    {
      // 项目列表
      path: '/company/project/list',
      component: ProjectList,
      isExact: true
    },
    {
      // 项目详情
      path: '/company/project/detail/:uuid',
      component: ProjectDetail,
      isExact: true
    },
    {
      // 项目新建
      path: '/company/project/create',
      component: ProjectCreate,
      isExact: true
    },
    {
      // 我的任务
      path: '/company/mytask',
      isExact: true,
      component: MyTask
    },
    // {
    //   // 项目详情中创建任务
    //   path: "/company/task/create/:uuid",
    //   isExact: true,
    //   component: TaskCreate,
    // },
    {
      // 我的任务中任务创建
      path: '/company/task/create',
      isExact: true,
      component: TaskCreate
    },
    {
      // 任务详情
      path: '/company/task/detail/:task_id',
      isExact: true,
      component: TaskDetail
    },
    {
      // 编辑描述详情
      path: '/company/task/edit/desc',
      isExact: true,
      component: Descript
    },
    {
      // 注册协议
      path: '/company/privacy',
      isExact: true,
      component: Privacy
    },
    {
      // 用户协议
      path: '/company/legal',
      isExact: true,
      component: Legal
    },
    {
      // app 下载跳板
      path: '/company/appdownload',
      isExact: true,
      component: AppDownload
    },
    {
      // app用户协议
      path: '/company/applegal',
      isExact: true,
      component: AppLegal
    },
    {
      // 白天鹅用户协议
      path: '/company/jzst-applegal',
      isExact: true,
      component: () => <AppLegal companyName="酒智生态" />
    },
    {
      // 白天鹅隐私策略
      path: '/company/jzst-privacy',
      isExact: true,
      component: () => <AppPrivacy name="酒智生态" />
    },
    {
      // App用户隐私策略
      path: '/company/appprivacy',
      isExact: true,
      component: AppPrivacy
    },
    {
      // 企业认证
      path: '/company/authcompany',
      isExact: true,
      component: AuthCompany
    },
    {
      // 企业认证
      path: '/company/instruction/workbench',
      isExact: true,
      component: WorkbenchIntro
    },
    {
      // 企业认证
      path: '/company/filepreview',
      isExact: true,
      component: FilePreview
    },
    {
      // 升级提示
      path: '/company/upgrade/tips',
      isExact: true,
      component: UpgradeTips
    },
    {
      // 蚂蚁链认证
      path: '/company/antpay',
      isExact: true,
      component: AntPay
    },
    {
      // 蚂蚁链认证结果
      path: '/company/antpay/result',
      isExact: true,
      component: AntPayResult
    },
    {
      // 个人实名认证
      path: '/company/personalverify',
      isExact: true,
      component: PersonalVerify
    }
  ]
};
